import baseAPI from "@/http";

const router = "api/municipio";

export const cityAPI = {
  create: (city) => baseAPI.post(router, city),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),

  getPorUf: (id, uf, parceiro) =>
    baseAPI.get(
      `${router}/obter-municipio-por-uf/?id=${id}&uf=${uf}&parceiro=${parceiro}`
    ),
  getMunicipioTema: (temaId, usuarioId) =>
    baseAPI.get(
      `${router}/get-municipios-tema?temaId=${temaId}&usuarioId=${usuarioId}`
    ),
  listNames: () => baseAPI.get(router + "/get-nomes"),
  getTasksReport: (id) => baseAPI.get(`${router}/relatorio-tarefa/${id}`),
  updateImageMunicipio: (val) => baseAPI.put(`${router}/update-imagem`, val),
  getRadar: (fill) => baseAPI.post(`${router}/get-radar`, fill),
  getMiniDash: (municipioId) =>
    baseAPI.get(`${router}/get-mini-dash/${municipioId}`),
  getMunicipioGov: (municipioId) =>
    baseAPI.get(`${router}/get-municipio-gov/${municipioId}`),
  obterUfsMunicipios: (email, parceiro) =>
    baseAPI.get(`${router}/obter-ufs${email ? `?email=${email}` : ""}`),
  obterMunicipioUfParceiro: (
    uf,
    parceiro,
    filtrarSemResponsavel,
    emailResponsavel
  ) =>
    baseAPI.get(
      `${router}/obter-municpio-por-uf-parceiro?uf=${uf}&parceiro=${parceiro}&filtrarSemResponsavel=${filtrarSemResponsavel}&emailUsuario=${emailResponsavel}`
    ),
  cadastrarMunicipio: (city) =>
    baseAPI.post(`${router}/cadastrar-municipio`, city),
};
